import { Component, OnInit, HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from 'src/app/globals';
import * as $ from "jquery";
import { Router, NavigationEnd } from '@angular/router';
import { LocationStrategy } from '@angular/common';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'eKyc';
  test: any;
  public isPopState = false;

  constructor(private httpClient: HttpClient, private globals: Globals, private router: Router, private locStrat: LocationStrategy){}
  ngOnInit(){
    this.scroll();
    /*this.httpClient.get("./api-pointings/environments.json").subscribe(data =>{
      this.test = JSON.parse(JSON.stringify(data));
      this.globals.App_Context = this.test.context;
      this.globals.selectedEnv = this.test.selectedEnv;
      for (let key in this.test) {
        if(key == this.globals.selectedEnv) {
          this.globals.CONTEXT_PATH = JSON.parse(JSON.stringify(this.test[key])).CONTEXT_PATH;
          this.globals.BACKEND_URL_PREFIX = JSON.parse(JSON.stringify(this.test[key])).BACKEND_URL_PREFIX;
        }
      }
      console.log("========App_Context======="+this.globals.App_Context);
      console.log("========selectedEnv======="+this.globals.selectedEnv);
      console.log("========CONTEXT_PATH======="+this.globals.CONTEXT_PATH);
      console.log("========BACKEND_URL_PREFIX======="+this.globals.BACKEND_URL_PREFIX);
    });*/
  }

  scroll(){
    this.locStrat.onPopState(() => {
      this.isPopState = true;
    });
     
    this.router.events.subscribe(event => {
    // Scroll to top if accessing a page, not via browser history stack
    if (event instanceof NavigationEnd && !this.isPopState) {
      window.scrollTo(0, 0);
      this.isPopState = false;
    }
     
    // Ensures that isPopState is reset
    if (event instanceof NavigationEnd) {
      this.isPopState = false;
    }
    });
  }
  /*@HostListener('document:keyup', ['$event'])
  onKeyUp (event: KeyboardEvent) {
    if (event.keyCode == '44' || event.keyCode == '123') {
      event.preventDefault()
    }
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }*/
}
